import React from 'react';
import { Table, Input, Button, Modal,Segment,Dimmer,Loader } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { AuthService } from '../../services/auth-service'
import { apiUrl } from "../../config.js"
import {convertSqlDatetimeToDate} from '../../helpers/csv-helpers'
import CreateCase from '../service-management/create-case';


class MeterReadTable extends React.Component {
  constructor(props) {
    super(props);
    this.authServices = new AuthService();


    this.state = {
      meterReadRows: [],
      setOpen : false,
      showErrorHide: true,
      statusFileId : "",
      showSuccessHide: true,
      uploadStatusList : [],
      downloadingFile : false
    };
  }

  componentDidMount() {
    this.loadMeterReadRows();
  }

  loadMeterReadRows = () => {
this.setState({downloadingFile : true})

    axios({
      url: `${apiUrl}/MeterReads/MeterReadSiteList/${this.props.customerId}/${this.props.siteKey}`,
      method: 'POST',       // Worked using POST or PUT. Prefer POST
      headers: {
        'Authorization': `bearer ${localStorage.getItem("token")}`
      }
      
      //responseType: 'blob', // important
    })
      .then(response => {
        this.setState({downloadingFile : false})

        this.setState({ meterReadRows: response.data.meterReadRows });
      })
      .catch(error => {
        this.setState({downloadingFile : false})

      });
  };

  handleClose = () => {
    this.props.handleClose();
  }

  handleMeterReadChange = (index, field, value) => {
    const newRows = [...this.state.meterReadRows];
    newRows[index][field] = value;
    this.setState({ meterReadRows: newRows });
  };

  downloadstatusDocument = () => {
    this.setState({
    
        downloadingFile : true
    });
    axios({
        url: `${apiUrl}/MeterReads/GetResultsFile/${this.state.statusFileId}`,
        method: 'POST',       // Worked using POST or PUT. Prefer POST
        headers: {
            'Authorization': `bearer ${localStorage.getItem("token")}`
        },
        responseType: 'blob', // important
    }).then((response) => {
        this.setState({
    
            downloadingFile : false
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
    
            link.setAttribute('download', 'resultStatusFile.csv');

        
        document.body.appendChild(link);
        link.click();
    });
}

  handleSubmit = () => {
    this.setState({downloadingFile : true})


    axios({
        url: `${apiUrl}/MeterReads/SubmitSiteMeterReads/${this.props.customerId}`,
        method: 'POST',       // Worked using POST or PUT. Prefer POST
        headers: {
          'Authorization': `bearer ${localStorage.getItem("token")}`
        },
        data: this.state.meterReadRows
        //responseType: 'blob', // important
      })
        .then(response => {
          response = response.data
          //this.setState({ meterReadRows: response.data.meterReadRows });
          this.setState({downloadingFile : false})

      
            if (response.hasErrors) {
                this.setState({
                    showErrorHide: false,
                    showSuccessHide: true,

                    uploadStatusList: response.statusList,
                    statusFileId : response.statusFileId
                })



            } else {
                this.setState({
                    showSuccessHide: false,
                    showErrorHide: true,

                    uploadStatusList: response.statusList,
                    statusFileId : response.statusFileId
                })
               }

        

        })
        .catch(error => {
            this.setState({downloadingFile : false})

          console.error('Error Submitting meter reads:', error);
        });

  };

 

  render() {

    const submittedCount = (this.state.uploadStatusList && this.state.uploadStatusList.filter(item => item.endsWith('- read submitted')).length) || 0;
    const notSubmittedCount = this.state.uploadStatusList ? this.state.uploadStatusList.length - submittedCount : 0;


    return (
      <Modal open={this.props.modalOpen}>
        <Modal.Header>{this.props.siteAddress}</Modal.Header>
        <Modal.Content>
        <Segment>

<Dimmer active={this.state.downloadingFile}>
    <Loader>Submitting Reads</Loader>
</Dimmer>               
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Serial</Table.HeaderCell>
                <Table.HeaderCell>Utility</Table.HeaderCell>
                <Table.HeaderCell>Register ID</Table.HeaderCell>
                <Table.HeaderCell>Last Read</Table.HeaderCell>
                <Table.HeaderCell>Last Read Date</Table.HeaderCell>
                <Table.HeaderCell>Last Type Date</Table.HeaderCell>

                <Table.HeaderCell>New Read Date</Table.HeaderCell>
                <Table.HeaderCell>New Read</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.state.meterReadRows.map((row, index) => (
                <Table.Row key={row.meterSiteKey}>
                  <Table.Cell>{row.serialNumber}</Table.Cell>
                  <Table.Cell>{row.utility}</Table.Cell>
                  <Table.Cell>{row.registerID}</Table.Cell>
                  <Table.Cell>{row.lastReading}</Table.Cell>
                  <Table.Cell>{convertSqlDatetimeToDate(row.dateLastRead)}</Table.Cell>
                  <Table.Cell>{row.lastReadType}</Table.Cell>
                  <Table.Cell>
                  <DatePicker
      selected={row.dateRead}
      dateFormat='dd/MM/yyyy'
      onChange={(date) =>

         {
        if (date) {
          date.setHours((-1 * date.getTimezoneOffset()) / 60);
        }

        this.handleMeterReadChange(index, 'dateRead', date)
      }
      }
    />
</Table.Cell>
                  <Table.Cell>
                    <Input
                      type="number"
                      min={0} // set the minimum value to 0
                      value={row.MeterReadValueNew}
                      onChange={(event) =>
                        this.handleMeterReadChange(
                          index,
                          'newReading',
                          event.target.value,
                        )
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>

            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan={3}>
                  <Button
                    primary
                    onClick={this.handleSubmit}
                  >
                    Submit All Reads
                  </Button>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>


          <div className="ui error message" hidden={this.state.showErrorHide}>
                    <div className="header">
                    Thank you for submitting your meter reads. {submittedCount} valid reads have been submitted and will be forwarded to your supplier shortly, but please be aware that the suppliers are not obligated to use this information. 
                    <br />                    <br />

                    Unfortunately {notSubmittedCount} reads could not be submitted. Details can be downloaded by clicking the button below. If you need assistance with failed reads please contact us direct or raise a case.  <br />  <br />
                    {(this.authServices.hasCaseManActive(this.props.customerId)) &&

                    <CreateCase></CreateCase>
  }
</div>

 <div>                        <Button icon='download' onClick={() => this.downloadstatusDocument()} color='green'></Button>                                      
                  
                </div>
                </div>
               

                <div className="ui positive message" hidden={this.state.showSuccessHide}>
                <div className="header">
                    Thank you for submitting your meter reads. {submittedCount} valid reads have been submitted and will be forwarded to your supplier shortly, but please be aware that the suppliers are not obligated to use this information. 
                    <br />                    <br />
</div>

 <div>                        <Button icon='download' onClick={() => this.downloadstatusDocument()} color='green'></Button>                                      
                  
                </div>

                </div>
                </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.handleClose}>Close</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default MeterReadTable;
